import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import {
  ProfileModel,
  RestaurantBranchRestControllerService,
  SmartDineResponseRestaurantBranchEntity,
} from 'src/app/swagger';
import { RestaurantBranchEntity } from 'src/app/swagger';
import { RestaurantsService } from '../../services/restaurants/restaurants.service';
import { UserProfileService } from '../../services/user-profile/user-profile.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-resto-branch-upsertion',
  templateUrl: './resto-branch-upsertion.component.html',
  styleUrls: ['./resto-branch-upsertion.component.scss'],
  standalone: false,
})
export class RestoBranchUpsertionComponent implements OnInit {
  public static readonly id = 'resto-branch-upsertion-modal';

  @Input()
  public restaurantId: string | null = null;

  @Input()
  public restaurantBranchId: string | null = null;

  @Input()
  public modalTitle: string = '';
  @Input()
  public branchData: RestaurantBranchEntity | null = null;

  public form: FormGroup;
  private branch: RestaurantBranchEntity | null = null;
  private userProfile: ProfileModel | null = null;

  constructor(
    private modalController: ModalController,
    private userProfileService: UserProfileService,
    private manageBranchService: RestaurantBranchRestControllerService,
    private restaurantsService: RestaurantsService,
    private toastController: ToastController
  ) {
    this.createForm();
  }

  public ngOnInit() {
    this.init();
  }

  public onSaveClick() {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.save();
    }
  }

  public onCloseClick() {
    this.modalController.dismiss('', '', RestoBranchUpsertionComponent.id);
  }

  private init() {
    this.setUserProfile();

    if (this.branchData) {
      this.branch = this.branchData;
      this.form.patchValue(this.branch);
    }
  }

  private setUserProfile() {
    this.userProfile = null;
    this.userProfileService.getUserProfile().subscribe({
      next: (userProfile: ProfileModel) => {
        this.userProfile = userProfile;
      },
    });
  }

  private async setBranch(): Promise<void> {
    const response: SmartDineResponseRestaurantBranchEntity =
      await lastValueFrom(
        this.manageBranchService.getRestaurantBranch(
          this.restaurantId,
          this.restaurantBranchId
        )
      );
    if (response && response?.item) {
      this.branch = response?.item;
      this.form.patchValue(this.branch);
    }
  }

  private createForm() {
    this.form = new FormGroup({
      name: new FormControl('', [Validators.required]),
      description: new FormControl('', []),
      restaurantBranchCode: new FormControl('', [Validators.required]),
      address: new FormControl('', []),
      city: new FormControl('', []),
      state: new FormControl('', []),
      country: new FormControl('', []),
      countryCode: new FormControl('', []),
      emailId: new FormControl('', []),
      website: new FormControl('', []),
      contactNumber: new FormControl('', []),
      pincode: new FormControl('', []),
      gstIN: new FormControl('', []),
    });
  }

  private save() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.showToast('Please fill all the required fields.');
      return;
    }

    const branch = this.branch || ({} as RestaurantBranchEntity);
    const now = new Date();

    Object.assign(branch, this.form.value);

    if (this.branch) {
      branch.modifier = this.userProfile.userId;
      branch.modifiedAt = now;
    } else {
      branch.restaurantBranchId = null;
      branch.creator = this.userProfile.userId;
      branch.createdAt = now;
      branch.restaurantId = this.restaurantId;
      branch.restaurantBranchImages = [];
    }

    this.createUpdateBranch(branch);
  }

  private async createUpdateBranch(
    branch: RestaurantBranchEntity
  ): Promise<void> {
    let response: SmartDineResponseRestaurantBranchEntity;

    if (this.restaurantId && this.restaurantBranchId) {
      response = await lastValueFrom(
        this.manageBranchService.updateRestaurantBranch(
          branch,
          this.restaurantId,
          this.restaurantBranchId
        )
      );
    } else {
      response = await lastValueFrom(
        this.manageBranchService.createRestaurantBranch(
          branch,
          branch?.restaurantId
        )
      );
    }

    this.restaurantsService.getBranches(true);
    this.showToast(
      `Branch - ${branch.name} ${
        this.restaurantBranchId ? 'Updated ' : 'Created '
      } Successfully!`
    );
    this.modalController.dismiss('', '', RestoBranchUpsertionComponent.id);
  }

  private async showToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
    });
    toast.present();
  }
}
